export default __webpack_public_path__ + "static/media/img-stack.15cfc079.svg";